export default {
    imageCode: "/gateway/manageBedrock/messagecs/createImageCode", //获取图片验证码
    messageCode: "/gateway/manageBedrock/messagecs/messageCode", //发送短信验证码
    inviteRegister: "/gateway/huilianOperation/invitecs/inviteRegister", // 注册
};



// WEBPACK FOOTER //
// ./src/inviteNewUsers/share/api.js